import React, { useEffect, useMemo, useState } from 'react';
import { useProductLivePreview } from '../../features/pdp/hooks/useProductLivePreview';
import { getMobileItems } from 'components/PdpImageGallery/helpers';
import { MobileImageGalleryContainer } from 'components/PdpImageGallery/styled';
import ImageGallery from 'react-image-gallery';
import { MediaObject } from '../../types/media';
import { LIVE_PREVIEW_MOBILE_INDEX } from 'constants/pdp';
import cx from 'classix';
import { useShouldDisplayImageCarouselTest } from '../../hooks/splits/useShouldDisplayImageCarouselTest';
import { useShouldDisplayPdpMobileTest } from '../../hooks/splits/useShouldDisplayPdpMobileTest';
import { SocialProof } from 'components/PdpImageGallery/SocialProof';

export interface ImageGalleryProps {
  photos: MediaObject[];
  onImageClick: (src: string) => void;
  sku?: string;
}

export const MobileImageGallery: React.FC<ImageGalleryProps> = ({ photos, onImageClick, sku }) => {
  const livePreviewUrl = useProductLivePreview();
  // If there is a live preview, start with that selected
  const [currentIndex, setCurrentIndex] = useState(livePreviewUrl ? LIVE_PREVIEW_MOBILE_INDEX : 0);
  const [currentLivePreview, setCurrentLivePreview] = useState(livePreviewUrl);

  const mobileItems = useMemo(() => getMobileItems(photos, onImageClick), [onImageClick, photos]);

  const showImageCarousel = useShouldDisplayImageCarouselTest();
  const showPdpMobileTest = useShouldDisplayPdpMobileTest();

  useEffect(() => {
    if (livePreviewUrl !== currentLivePreview) {
      setCurrentIndex(LIVE_PREVIEW_MOBILE_INDEX);
      setCurrentLivePreview(livePreviewUrl);
    }
  }, [livePreviewUrl, currentLivePreview]);

  return (
    <MobileImageGalleryContainer className={cx(
      'mobile-image-gallery-container',
      showImageCarousel && 'image-carousel-test'
    )}>
      <ImageGallery
        items={mobileItems}
        startIndex={currentIndex}
        thumbnailPosition="left"
        thumbnailClass="image-gallery-thumbnail"
        showPlayButton={false}
        showFullscreenButton={false}
        showNav={false}
        showThumbnails={false}
        showBullets={false}
        swipeThreshold={20}
        flickThreshold={0.2}
      />
      {showPdpMobileTest && <SocialProof />}
    </MobileImageGalleryContainer>
  );
};
